import { render, staticRenderFns } from "./PriceChange.vue?vue&type=template&id=cdc0c4e6&scoped=true&"
import script from "./PriceChange.vue?vue&type=script&lang=js&"
export * from "./PriceChange.vue?vue&type=script&lang=js&"
import style0 from "./PriceChange.vue?vue&type=style&index=0&id=cdc0c4e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc0c4e6",
  null
  
)

export default component.exports